import { usePriceQuery } from "../hooks/PriceQuery";
import { LocalizedDateTime } from "./LocalizedDate";
import { css } from "./SKT";
import { SKTProgressBar } from "./SKTProgressBar";
import {
  SKTTable,
  SKTTableBody,
  SKTTableHeader,
  SKTTableRow,
} from "./SKTTable";
import { SKTToggle } from "./SKTToggle";

const ResultContainer = ({ children }) => {
  return (
    <div className={css("query-results")}>
      <p className={css("order-results")}>{children}</p>
    </div>
  );
};

const RawResult = ({ rows }) => {
  return (
    <SKTTable>
      <SKTTableHeader>
        <tr>
          <th></th>
          <th></th>
          <th>Osto</th>
          <th>Myynti</th>
          <th>ALV</th>
        </tr>
      </SKTTableHeader>
      <SKTTableBody>
        {rows.map((row) => (
          <tr>
            <td>{row.carrier}</td>
            <td>{row.name}</td>
            <td>{row.in.toFixed(2)} €</td>
            <td>{row.out.toFixed(2)} €</td>
            <td>{row.vat.toFixed(2)} €</td>
          </tr>
        ))}
      </SKTTableBody>
    </SKTTable>
  );
};

export const SKTResults = ({ url, data, requiredFields, additionalFields }) => {
  const price = usePriceQuery(url, data, requiredFields, additionalFields);

  if (price.status === "empty") return <ResultContainer />;
  if (price.status === "cancelled") return <ResultContainer />;
  if (price.status === "error")
    return (
      <ResultContainer>
        Palvelussa on tekninen ongelma, yritä myöhemmin uudestaan!
      </ResultContainer>
    );
  if (price.status === "no_price")
    return (
      <ResultContainer>
        Valitettavasti emme pysty laskemaan hintaa nyt annetuilla tiedoilla. Ota
        yhteys asiakaspalveluun!
      </ResultContainer>
    );
  if (price.status === "pending")
    return (
      <ResultContainer>
        <SKTProgressBar label="Hintaa haetaan" />
      </ResultContainer>
    );

  return (
    <ResultContainer>
      <SKTToggle when={!price.raw}>
        <p>
          <strong>Kuljetuksen hinta:</strong>{" "}
          <span className={css("price")}>{price.price}&nbsp;&euro;</span>&nbsp;
          (sis. ALV {price.vatPercent}%; ALV:n osuus {price.vat}&euro;)
        </p>
        <SKTToggle when={price.pickup}>
          <p>
            Arvioitu noutoaika on <LocalizedDateTime datetime={price.pickup} />{" "}
            mennessä.
          </p>
        </SKTToggle>
        <SKTToggle when={price.delivery}>
          <p>
            Arvioitu toimitusaika on{" "}
            <LocalizedDateTime datetime={price.delivery} /> mennessä.
          </p>
        </SKTToggle>
      </SKTToggle>
      <SKTToggle when={price.raw}>
        <RawResult rows={price.raw} />
      </SKTToggle>
    </ResultContainer>
  );
};
